import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '../utils/cn';

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  const defaultClasses =
    orientation === 'horizontal' ? 'w-full h-[1px]' : 'self-stretch w-[1px]';
  return (
    <SeparatorPrimitive.Root
      data-slot='separator'
      decorative={decorative}
      orientation={orientation}
      className={cn('bg-quaternary shrink-0', defaultClasses, className)}
      {...props}
    />
  );
}

export { Separator };
